import { render, staticRenderFns } from "./editorimage.vue?vue&type=template&id=4f5f783e&scoped=true&"
import script from "./editorimage.vue?vue&type=script&lang=js&"
export * from "./editorimage.vue?vue&type=script&lang=js&"
import style0 from "./editorimage.vue?vue&type=style&index=0&id=4f5f783e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f783e",
  null
  
)

export default component.exports